import {
  ArrowRight,
  PartyPopper,
  Shield,
  Sparkles,
  Ticket,
} from "lucide-react";
import { Link } from "react-router-dom";

export const Landing = () => (
  <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] to-black text-white">
    {/* Hero Section */}
    <div className="container mx-auto px-4 pt-20 pb-32">
      <div className="text-center animate-fade-up">
        <img
          src="/logo.jpg"
          alt="Agent FOMO Logo"
          className="mx-auto h-40 mb-8 rounded-lg shadow-lg hover:scale-105 transition-transform duration-300"
        />
        <span className="px-4 py-1.5 rounded-full bg-purple-500/10 text-purple-400 inline-block mb-4">
          Your Underground Scene Guide
        </span>
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          Meet Agent FOMO
        </h1>
        <p className="text-xl md:text-2xl text-gray-400 mb-8 max-w-2xl mx-auto">
          Discover exclusive events, secret parties, and underground gatherings
          in your city. Never miss out again.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://wa.me/972504244206"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 rounded-full bg-purple-600 hover:bg-purple-700 text-white font-semibold transition-all hover:scale-105"
          >
            Start Chatting <ArrowRight className="ml-2" />
          </a>
          <Link
            to="/app"
            className="inline-flex items-center px-8 py-4 rounded-full border border-purple-600 text-purple-400 hover:bg-purple-600/10 font-semibold transition-all hover:scale-105"
          >
            Go to App <Sparkles className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </div>
    </div>

    {/* Features */}
    <div className="container mx-auto px-4 py-24 bg-black/30">
      <div className="grid md:grid-cols-3 gap-8">
        <div
          className="glass-card p-6 animate-fade-up"
          style={{ animationDelay: "0.1s" }}
        >
          <PartyPopper className="w-12 h-12 text-purple-500 mb-4" />
          <h3 className="text-xl font-semibold mb-2">Exclusive Events</h3>
          <p className="text-gray-400">
            From underground raves to intimate gatherings, find events that
            match your vibe.
          </p>
        </div>
        <div
          className="glass-card p-6 animate-fade-up"
          style={{ animationDelay: "0.2s" }}
        >
          <Ticket className="w-12 h-12 text-purple-500 mb-4" />
          <h3 className="text-xl font-semibold mb-2">Best Deals</h3>
          <p className="text-gray-400">
            Exclusive discounts and early bird offers for the hottest events.
          </p>
        </div>
        <div
          className="glass-card p-6 animate-fade-up"
          style={{ animationDelay: "0.3s" }}
        >
          <Shield className="w-12 h-12 text-purple-500 mb-4" />
          <h3 className="text-xl font-semibold mb-2">Verified Events</h3>
          <p className="text-gray-400">
            All events are verified and curated for your peace of mind.
          </p>
        </div>
      </div>
    </div>

    {/* Footer */}
    <footer className="container mx-auto px-4 py-8">
      <div className="flex flex-col items-center mb-4">
        <img
          src="/logo.jpg"
          alt="Agent FOMO"
          className="h-12 w-auto opacity-80 rounded text-center"
        />
      </div>
      <div className="flex justify-center space-x-4 text-sm text-gray-400">
        <Link to="/privacy" className="hover:text-white transition-colors">
          Privacy Policy
        </Link>
        <Link to="/terms" className="hover:text-white transition-colors">
          Terms & Conditions
        </Link>
        <Link
          to="/accessibility"
          className="hover:text-white transition-colors"
        >
          Accessibility
        </Link>
      </div>
    </footer>
  </div>
);
